import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { MealPhotoScannerPage } from './meal-photo-scanner-page';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [MealPhotoScannerPage],
    imports: [PagesModule, ComponentsModule]
})
export class MealPhotoScannerPageModule { }
